<script>
  import Course from '@components/List/Course'
  import { FAKE_EVENT_LIST_2 } from "@src/config/fake-evnet";

  export default {
    components: {
      Course,
    },
    props: {
      eventList: {
        type: Array,
        default: () => {
          return FAKE_EVENT_LIST_2
        }
      }
    },
  }
</script>

<template>
  <div id="event" class="section" :class="$style.sectionEvent">
    <div class="container">
      <BaseSectionTitle title="課程活動" class="text-center"/>
      <div class="mb-4">
        <Course
          :course-list="eventList"
          type="isSwiper"
        />
      </div>
      <div class="text-center">
        <BaseButton
          class="isStylePrimary isRadius isCol4 isPosition"
          :to="{ name: 'brand-event-list' }"
        >
          查看所有課程
        </BaseButton>
      </div>
    </div>
  </div>
</template>

<style lang="scss" module>
  .sectionEvent {
    background-color: $color-gray-2;
    :global {
      .sectionEvent {
        @include unstyled;
      }
    }
  }
</style>
